import API from './index';

const api = {
    getLandingData(role) {
        return API.authAPI({
            url: '/landing/get-landing-count',
            method: 'GET',
            params: {
                role,
            },
        });
    },
    exportSiteInfo({ data }) {
        return API.authAPI({
            url: `/application/export-site-info-reminder`,
            method: 'POST',
            responseType: 'blob',
            timeout: 1000 * 60 * 10,
            data,
        });
    },
};

export default api;
